<div id="heading" class="standard-heading">
  <h1>Seminars / Conferences</h1>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
      <li class="breadcrumb-item"><a href="#">About Us</a></li>
      <li class="breadcrumb-item" routerLink="/about/research-centre"><a href="#">Research Centre</a></li>
      <li class="breadcrumb-item active" aria-current="page">Seminars / Conferences</li>
    </ol>
  </nav>
</div>

<section id="seminar-conference" class="py-5">
  <div class="container">
    <div class="card shadow-lg content-main-card border-0">
      <div class="card-body p-4 p-md-5 text-center">
        <h2 class="card-title text-uppercase mb-3">Seminars / Conferences</h2>
        <hr class="mx-auto mb-5 custom-hr">

        <div class="seminar-details text-start d-inline-block">
          <ul class="lead text-justify mb-0" style="font-size: 1.3rem; line-height: 2.1rem; font-weight: 500;">
            <li class="mb-2">
              Ministry of Culture, Government of India and Sahitya Akademi, New Delhi in collaboration with Guru Nanak Khalsa Group of Institutions, Haryana Organized National Seminar on “Legacy of Sri Guru Tegh Bahadur Ji” on 15th September, 2026.
            </li>
          </ul>
        </div>

        <div class="mt-5">
          <button class="btn btn-danger" routerLink="/about/research-centre">Back to Research Centre</button>
        </div>
      </div>
    </div>
  </div>
</section>
